import { DEFAULT_LOCALE, type Locale } from '@/i18n/config';
import { i18n } from '@/i18n/i18n';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface State {
  locale: Locale;
}

interface Actions {
  actions: {
    resetState: () => void;
    setLocale: (locale: State['locale']) => void;
  };
}

const initialState: State = {
  locale: DEFAULT_LOCALE
};

const useLocaleStore = createWithEqualityFn<State & Actions>(
  (set) => ({
    ...initialState,
    actions: {
      resetState: () => {
        set(initialState);
      },
      setLocale: (locale) => {
        void i18n.changeLanguage(locale);
        set(() => ({ locale }));
      }
    }
  }),
  Object.is
);

export const useLocaleState = () => useLocaleStore(({ actions: _, ...state }) => state, shallow);
export const useLocaleActions = () => useLocaleStore((state) => state.actions);
